import React, { Component } from 'react';

class ViewImage extends Component {
    render() {
        const { image } = this.props;
        return (
            <div className="col-4 image-info" >
                <div className="img-placeholder">
                    <img src={image} alt="" />
                </div>
            </div>
        )
        // return (
        //     <div className={this.props.styleName}>
        //         {
        //             images.length ?
        //                 images.map((image, i) => (
        //                     <div key={i} className="col-4 image-info">
        //                         <img src={image} alt="" />
        //                     </div>
        //                 )) : null
        //         }
        //     </div>
        // )
    }
}

export default ViewImage;
